import { useLocation } from '@tanstack/react-router';

// The backend's own parse: a non-negative integer, anything else is "absent"
// — so the SPA and the session guard always agree on which account a URL
// addresses.
export function parseAuthuser(raw: string | null): number | undefined {
  if (raw === null || raw === '') return undefined;
  const n = Number(raw);
  return Number.isInteger(n) && n >= 0 ? n : undefined;
}

// Read from the raw query: the value is the issuer's, kept as the string the
// URL carried on every route.
export default function useAuthuser(): number | undefined {
  const searchStr = useLocation({ select: (location) => location.searchStr });
  return parseAuthuser(new URLSearchParams(searchStr).get('authuser'));
}
